module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av47-333e695af3e5887762cffef58250a7cd.jpg";